function isNil(value) {
    return value === undefined || value === null || Number.isNaN(value);
}
function isNilOrEmptyString(value) {
    return isNil(value) || value === '';
}

export { isNil, isNilOrEmptyString };
//# sourceMappingURL=utils.esm.js.map
